module.exports = __webpack_public_path__ + "img/43-l.cf0b8a9e.png";